import itemallComponent from './item.all.component';

let itemallModule = angular.module('itemall', [])

  .component('itemall', itemallComponent)
  .name;

export default itemallModule;


// WEBPACK FOOTER //
// ./client/app/components/item/all/index.js